import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconVimeo$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconVimeo extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '90259c3841cc416fa634aca1f7e724c8c0fe5c71', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '8d358676421b418286261d3d0b384e870bcb403e', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '921e626ecf7238cee0b2521eb6b1eeab17874a60', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.145 7.672q-.096 2.094-2.914 5.732c-1.951 2.525-3.594 3.78-4.936 3.78-.839 0-1.501-.76-2.12-2.297-.38-1.413-.768-2.826-1.147-4.239-.433-1.545-.884-2.296-1.378-2.296a4.3 4.3 0 0 0-1.122.672l-.68-.883 2.093-1.864a4.64 4.64 0 0 1 2.12-1.29c1.112-.105 1.766.654 2.048 2.288s.45 2.844.583 3.285c.318 1.457.671 2.19 1.06 2.19.388 0 .75-.477 1.342-1.422.487-.64.828-1.378.998-2.163.088-.821-.23-1.228-.963-1.228a2.8 2.8 0 0 0-1.05.23q1.015-3.453 3.991-3.347c1.466 0 2.155.99 2.075 2.852", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-vimeo", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-vimeo"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-vimeo":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconVimeo$1);
            }
            break;
    } });
}

const CosmosIconVimeo = CosmosIconVimeo$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconVimeo, defineCustomElement };
